import React from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getMessageTypePreview, isMediaProcessing } from '../utils/messageTypePreview';
import { formatMessageTime } from '../utils/formatMessageTime';

// Terceira linha do header do card: prévia da última mensagem (texto ou
// ícone+rótulo quando for mídia) + horário/"ontem"/data, sempre fixo à direita.
const LeadLastMessagePreview = ({
  lastMessageText,
  lastMessageType,
  lastMessageDuration,
  lastMessageAt,
}) => {
  const { t, i18n } = useTranslation();
  const mediaPreview = getMessageTypePreview(lastMessageType, t, lastMessageDuration);
  const processing = isMediaProcessing(lastMessageType, lastMessageDuration);

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.5}
      sx={{ flex: 1, minWidth: 0 }}
    >
      {mediaPreview ? (
        <Stack
          direction="row"
          alignItems="center"
          spacing={0.5}
          color="text.secondary"
          sx={{
            flex: 1,
            minWidth: 0,
            ...(processing && {
              animation: 'lastMessageBlink 1.4s ease-in-out infinite',
              '@keyframes lastMessageBlink': {
                '0%, 100%': { opacity: 1 },
                '50%': { opacity: 0.3 },
              },
            }),
          }}
        >
          {mediaPreview.icon}
          <Typography variant="body2" color="text.secondary" noWrap>
            {mediaPreview.label}
          </Typography>
        </Stack>
      ) : (
        <Typography variant="body2" color="text.secondary" noWrap sx={{ flex: 1, minWidth: 0 }}>
          {lastMessageText}
        </Typography>
      )}

      <Typography variant="caption" color="text.secondary" sx={{ flexShrink: 0 }}>
        {formatMessageTime(lastMessageAt, t, i18n.language)}
      </Typography>
    </Stack>
  );
};

export default LeadLastMessagePreview;
